<template>
    <div class="main-content">
        <!-- 页面顶部栏：返回 + 保存 -->
        <div class="page-top-header">
            <el-button type="default" icon="el-icon-arrow-left" @click="handleBack">返回</el-button>
            <el-button type="primary" @click="handleUnifiedSave" :disabled="!currentStep || submitStatus != 0">保存设置</el-button>
        </div>
        <div class="content-area">
        <div class="left-content">
            <div class="left-content-header">
                <div class="step-action-wrapper">
                    <el-select v-model="value" placeholder="请选择标段" @change="handleSectionChange"
                        :disabled="isSectionDropdownDisabled">
                        <el-option :label="item.bidSectionName" :value="item.bidSectionCode" v-for="item in sectionList"
                            :key="item.bidSectionCode"></el-option>
                    </el-select>

                    <div class="step-action-buttons">
                        <el-button ref="createStepBtn" type="primary" :disabled="!value" @click="handleCreateSteps">
                            创建评审步骤
                        </el-button>
                        <el-button :disabled="!value" @click="showTemplateModal = true"  type="primary">
                            使用模版创建
                        </el-button>

                        <el-button type="primary" @click="handleCopyStep">
                            复制
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="dropdown-menu" v-show="showDropdown" ref="dropdownMenu">
                <div class="dropdown-item"
                    v-for="t in stepTypeList.filter(i => i.stepTypeCode && i.stepTypeCode.length === 2 && i.stepTypeCode !== '06')"
                    :key="t.stepTypeCode" @click="handleStepTypeClickByCode(t.stepTypeCode)">
                    {{ t.stepTypeName }}
                </div>
                <div class="dropdown-item has-submenu"
                    v-if="stepTypeList.some(i => i.stepTypeCode && i.stepTypeCode.startsWith('06') && i.stepTypeCode.length > 2)"
                    @mouseenter="showSubmenu = true" @mouseleave="showSubmenu = false">
                    可选评审步骤>
                    <div class="submenu" v-show="showSubmenu">
                        <div class="submenu-item"
                            v-for="t in stepTypeList.filter(i => i.stepTypeCode && i.stepTypeCode.startsWith('06') && i.stepTypeCode.length > 2)"
                            :key="t.stepTypeCode" @click="handleStepTypeClickByCode(t.stepTypeCode)">
                            {{ t.stepTypeName }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 未选择标段提示 -->
            <div class="empty-placeholder" v-if="!value">
                <i class="el-icon-folder-opened"></i>
                <p>请先选择标段</p>
            </div>
            <!-- 无步骤数据提示 -->
            <div class="empty-placeholder" v-else-if="leftSteps.length === 0">
                <i class="el-icon-document-add"></i>
                <p>暂无评审步骤，请点击“创建评审步骤”添加</p>
            </div>
            <!-- 菜单项 -->
            <template v-else>
                <div class="left-content-item" v-for="step in leftSteps" :key="step.id" draggable="true"
                    @dragstart="handleDragStart(step)" @dragover.prevent @drop="handleDrop(step)"
                    :class="{ active: currentStep === step.id }"  @click.stop="handleStepClick(step)">
                    <div style="display: flex;">
                        <i class="el-icon-s-flag"></i>
                        <div style="margin-left: 5px;">{{ step.stepName }}</div>
                    </div>
                    <div class="left-content-item-button">
                        <!-- <div style="flex-shrink: 0" @click.stop="handleStepClick(step)">编辑</div> -->
                        <div style="flex-shrink: 0" @click.stop="delStepEvent(step.id)">删除</div>
                    </div>
                </div>
            </template>

        </div>
        <div class="right-content">
            <!-- 未选择步骤提示 -->
            <div class="empty-placeholder right-empty" v-if="!value">
                <i class="el-icon-s-operation"></i>
                <p>请先选择标段</p>
            </div>
            <div class="empty-placeholder right-empty" v-else-if="!currentStep">
                <i class="el-icon-s-order"></i>
                <p>请在左侧选择一个评审步骤进行编辑</p>
            </div>
            <template v-else>
                <div class="right-content-header">
                    <span style="font-size: 20px; font-weight: bold;">{{ currentStepName }}</span>
                </div>
                <!-- 评审表单内容 -->
                <!-- 01 通过式评审 -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '01'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentPassReviewStep">保存</el-button>
                    </div>
                    <review-form ref="rightReviewForm" :form-data="currentStepData" :form-rules="formRules"
                        @update:formData="updateCurrentStepData" />
                </div>
                <!-- 02 打分式评审(技术/详细评审) -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '02'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentScoreReviewStep">保存</el-button>
                    </div>
                    <scoring-review-form ref="rightScoringReviewForm" :form-data="currentStepData"
                        :form-rules="formRules" @update:formData="updateCurrentStepData" />
                </div>
                <!-- 03 计算基准价 -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '03'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentBenchmarkStep">保存</el-button>
                    </div>
                    <benchmark-price-form ref="rightBenchmarkForm" :form-data="currentStepData" :form-rules="formRules"
                        @update:formData="updateCurrentStepData" :sectionId="sectionId" operType="update" />
                </div>
                <!-- 04 计算报价得分 -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '04'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentScoringCalculationStep">保存</el-button>
                    </div>
                    <scoring-calculation-form ref="rightScoringCalculationForm" :form-data="currentStepData"
                        :form-rules="formRules" @update:formData="updateCurrentStepData" :sectionId="sectionId"
                        :stepId="currentStep" />
                </div>
                <!-- 05 推荐候选人 -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '05'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentCandidateStep">保存</el-button>
                    </div>
                    <comprehensive-scoring-candidate-form ref="rightCandidateForm" :form-data="currentStepData"
                        :form-rules="formRules" @update:formData="updateCurrentStepData" :sectionId="sectionId"
                        operType="update" />
                </div>
                <!-- 0601 二次报价环节 -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '0601'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentSecondQuotationStep">保存</el-button>
                    </div>
                    <second-quotation-form ref="rightSecondQuotationForm" :form-data="currentStepData" />
                </div>
                <!-- 0602 小微企业认证环节 -->
                <div class="right-content-body" v-if="currentStepData && stepTypeCode == '0602'">
                    <div style="padding-bottom: 10px;">
                        <el-button type="primary" @click="saveCurrentSMEStep">保存</el-button>
                    </div>
                    <small-micro-enterprise-form ref="rightSmeForm" :form-data="currentStepData" />
                </div>
            </template>
        </div>
        </div>

        <!-- 通过式评审弹窗 -->
        <el-dialog title="通过式评审 (符合性/初步评审、资格审查)" :visible.sync="showModal" width="50%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeModal" destroy-on-close append-to-body>
            <review-form ref="reviewForm" :form-data="formData" :form-rules="formRules"
                @update:formData="updateFormData" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveReviewStep">保存</el-button>
            </div>
        </el-dialog>

        <!-- 打分式评审弹窗 -->
        <el-dialog title="详细评审 (打分式)" :visible.sync="showScoringModal" width="80%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeScoringModal" destroy-on-close append-to-body>
            <scoring-review-form ref="scoringReviewForm" :form-data="scoringFormData" :form-rules="scoringFormRules"
                @update:formData="updateScoringFormData" :in-dialog="true" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveScoringReviewStep">保存</el-button>
            </div>
        </el-dialog>

        <!-- 计算基准价弹窗 -->
        <el-dialog title="计算基准价" :visible.sync="showBenchmarkModal" width="70%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeBenchmarkModal" destroy-on-close append-to-body>
            <benchmark-price-form ref="benchmarkPriceForm" :form-data="benchmarkFormData"
                :form-rules="benchmarkFormRules" @update:formData="updateBenchmarkFormData" :sectionId="sectionId"
                :stepId="currentStep" :in-dialog="true" operType="add" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveBenchmarkStep">保存</el-button>
            </div>
        </el-dialog>

        <!-- 计算报价得分弹窗 -->
        <el-dialog title="计算报价得分" :visible.sync="showScoringCalculationModal" width="80%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeScoringCalculationModal" destroy-on-close append-to-body>
            <scoring-calculation-form ref="scoringCalculationForm" :form-data="scoringCalculationFormData"
                :form-rules="scoringCalculationFormRules" @update:formData="updateScoringCalculationFormData"
                :sectionId="sectionId" :in-dialog="true" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveScoringCalculationStep">保存</el-button>
            </div>
        </el-dialog>

        <!-- 推荐候选人弹窗 -->
        <el-dialog title="推荐候选人" :visible.sync="showCandidateModal" width="70%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeCandidateModal" destroy-on-close append-to-body>
            <!-- 根据选择的推荐方式显示不同的表单 -->
            <comprehensive-scoring-candidate-form ref="candidateForm" :form-data="candidateFormData"
                :form-rules="candidateFormRules" :sectionId="sectionId" operType="add"
                @update:formData="updateCandidateFormData" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveCandidateStep">保存</el-button>
            </div>
        </el-dialog>

        <!-- 二次报价环节弹窗 -->
        <el-dialog title="二次报价环节" :visible.sync="showSecondQuotationModal" width="50%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeSecondQuotationModal" destroy-on-close append-to-body>
            <second-quotation-form ref="secondQuotationForm" :form-data="secondQuotationFormData"
                :form-rules="secondQuotationFormRules" @update:formData="updateSecondQuotationFormData" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveSecondQuotationStep">保存</el-button>
            </div>
        </el-dialog>

        <!-- 小微企业认证环节弹窗 -->
        <el-dialog title="小微企业认证环节" :visible.sync="showSMEModal" width="50%" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeSMEModal" destroy-on-close append-to-body>
            <small-micro-enterprise-form ref="smeForm" :form-data="smeFormData" :form-rules="smeFormRules"
                @update:formData="updateSMEFormData" />

            <!-- 底部按钮 -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveSMEModal">保存</el-button>
            </div>

        </el-dialog>

            <!-- 评标方法模版选择弹窗 -->
        <el-dialog title="评标方法模版" :visible.sync="showTemplateModal" width="600px" :close-on-click-modal="false"
            :z-index="2000"
            :close-on-press-escape="false" @close="closeTemplateModal" append-to-body>
            <div class="template-dialog-content">
                <el-alert title="系统提供的都是标准评标方法模版，可根据需求选择使用，模版仅供参考，模版内具体内容支持修改。" type="info" :closable="false"
                    style="margin-bottom: 20px;">
                </el-alert>

                <div class="template-section">
                    <div class="template-section-title">采购类模版</div>
                    <div class="template-list">
                        <div class="template-item" v-for="template in templateList" :key="template.id">
                            <span class="template-name">{{ template.name }}</span>
                            <el-button type="text" @click="handleUseTemplate(template)">使用</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 复制评标办法 - 选择项目/标段弹窗 -->
        <el-dialog title="复制评标办法" :visible.sync="showCopyModal" width="900px" :close-on-click-modal="false"
            :close-on-press-escape="false" @close="closeCopyModal" append-to-body>
            <div class="copy-dialog-content">
                <div class="copy-search-bar">
                    <el-input v-model="copySearchKeyword" placeholder="请输入项目名称搜索" clearable
                        @clear="handleCopySearch" @keyup.enter.native="handleCopySearch" class="copy-search-input">
                        <el-button slot="append" icon="el-icon-search" @click="handleCopySearch"></el-button>
                    </el-input>
                </div>

                <el-table :data="copyProjectList" border v-loading="copyLoading" style="width: 100%;">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <div class="copy-section-list" v-if="scope.row.sectionNameVoList && scope.row.sectionNameVoList.length">
                                <div class="copy-section-item" v-for="s in scope.row.sectionNameVoList" :key="s.sectionCode">
                                    <span class="copy-section-name">{{ s.sectionName }}</span>
                                    <el-button type="text" @click="handleCopyRow(scope.row, s)">复制</el-button>
                                </div>
                            </div>
                            <div v-else style="color: #909399; padding: 8px 0;">暂无标段</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称" min-width="220"></el-table-column>
                    <el-table-column label="标段数" width="80" align="center">
                        <template slot-scope="scope">
                            {{ (scope.row.sectionNameVoList && scope.row.sectionNameVoList.length) || 0 }}
                        </template>
                    </el-table-column>
                </el-table>

                <div class="copy-pagination-wrapper">
                    <el-pagination background layout="total, prev, pager, next, jumper"
                        :total="copyPagination.total" :page-size="copyPagination.pageSize"
                        :current-page.sync="copyPagination.current" :page-sizes="[10, 20, 50]"
                        @current-change="handleCopyPageChange">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getDocuments,
    getStepTypeList,
    saveStep,
    getSectionList,
    addPassReview,
    addScoreReview,
    saveBasePrice,
    saveQuotationScoreStep,
    saveOptionalStep,
    saveRecommendStep,
    getStepListBySectionId,
    delStep,
    getStepDetailByStepId,
    getSubmitStatus,
    createStepByModel,
    getProjectSectionList,
    copyStep
} from '@/api/evaluationstep/api';
export default {
    name: 'BidEvaluationMethod',
    components: {
        'review-form': () => import('../../../components/common/review/ReviewForm.vue'),
        'scoring-review-form': () => import('../../../components/common/review/ScoringReviewForm.vue'),
        'benchmark-price-form': () => import('../../../components/common/review/BenchmarkPriceForm.vue'),
        'scoring-calculation-form': () => import('../../../components/common/review/ScoringCalculationForm.vue'),
        'manual-calculation-form': () => import('../../../components/common/review/reviewChild/ManualCalculationForm.vue'),
        'lowest-price-form': () => import('../../../components/common/review/reviewChild/LowestPriceForm.vue'),
        'average-price-form': () => import('../../../components/common/review/reviewChild/AveragePriceForm.vue'),
        'highest-limit-price-form': () => import('../../../components/common/review/reviewChild/HighestLimitPriceForm.vue'),
        'lowest-price-scoring-form': () => import('../../../components/common/review/reviewChild/LowestPriceScoringForm.vue'),
        'average-price-scoring-form': () => import('../../../components/common/review/reviewChild/AveragePriceScoringForm.vue'),
        'benchmark-price-scoring-form': () => import('../../../components/common/review/reviewChild/BenchmarkPriceScoringForm.vue'),
        'comprehensive-scoring-candidate-form': () => import('../../../components/common/review/reviewChild/ComprehensiveScoringCandidateForm.vue'),
        'lowest-price-candidate-form': () => import('../../../components/common/review/reviewChild/LowestPriceCandidateForm.vue'),
        'comprehensive-scoring-form': () => import('../../../components/common/review/reviewChild/ComprehensiveScoringForm.vue'),
        'second-quotation-form': () => import('../../../components/common/review/SecondQuotationForm.vue'),
        'small-micro-enterprise-form': () => import('../../../components/common/review/SmallMicroEnterpriseForm.vue'),
    },

    data() {
        return {
            submitStatus: 0,// 0提交 1是提交
            // 选择标段组件是否可以下拉
            isSectionDropdownDisabled: false,

            // 基础信息
            projectId: this.$route.query.projectId,     // 项目ID
            projectCode: this.$route.query.projectCode, // 项目编码
            sectionList: [],    // 标段列表
            sectionId: '',      // 当前选中的标段ID
            value: '',          // 当前选中的标段编码
            //左侧步骤列表相关
            leftSteps: [],          // 左侧步骤列表（从接口获取）
            stepTypeList: [],       // 步骤类型列表
            currentStepTypeInfo: null, // 当前选中的步骤类型信息
            stepOrderNum: 0,        // 步骤序号计数器
            // 右侧详情相关
            currentStep: 0,      // 当前选中的步骤ID
            currentStepName: '',    // 当前选中的步骤名称
            stepTypeCode: '',       // 当前步骤类型编码
            ruleMethod: null,       // 当前步骤的子类型（用于区分同一stepTypeCode下的不同表单）
            currentStepData: null,  // 当前步骤详情数据（传递给右侧表单）
            //拖拽排序相关
            dragSourceIndex: null,  // 拖拽源索引
            localStepOrder: null,   // 拖拽后本地记录的顺序（stepId 数组，保存设置成功后清除）
            // 弹窗显示控制
            showDropdown: false,            // 创建步骤下拉菜单
            showSubmenu: false,             // 可选步骤子菜单
            showModal: false,               // 通过式评审弹窗
            showScoringModal: false,        // 打分式评审弹窗
            showBenchmarkModal: false,      // 计算基准价弹窗
            showScoringCalculationModal: false, // 计算报价得分弹窗
            showCandidateModal: false,      // 推荐候选人弹窗
            showSecondQuotationModal: false,// 二次报价弹窗
            showSMEModal: false,            // 小微企业认证弹窗
            showTemplateModal: false,       // 评标方法模版弹窗
            showCopyModal: false,           // 复制评标办法弹窗
            copyProjectList: [],            // 复制弹窗 - 项目列表
            copySearchKeyword: '',          // 复制弹窗 - 搜索关键词
            copyLoading: false,             // 复制弹窗 - 加载状态
            copyPagination: {               // 复制弹窗 - 分页
                current: 1,
                pageSize: 10,
                total: 0
            },
            //弹窗表单数据（用于新建步骤）
            formData: { stepName: '', isBlindReview: 0, reviewItems: [{ reviewName: '', reviewStandard: '' }] },
            scoringFormData: {
                stepName: '',
                isBlindReview: 0,
                score: 100,
                scoreType: 1,
                addUpScore: true,
                maxScoreCount: 0,
                minScoreCount: 0,
                stepMarkType: 1,  // 1=明标, 2=暗标
                lastScoreSetting: 1,
                followUpSetting: 1,
                followUpCount: 1,
                skipStep: false,
                bidPersonCount: 0,
                scoreReasonType: '0',
                percent: 0,
                scoreReviewList: [{ reviewName: '', reviewStandard: '', scoreRange: '', scoreType: 1 }]
            },
            benchmarkFormData: { stepName: '', calculateType: null },
            scoringCalculationFormData: { stepName: '', calculateType: null },
            candidateFormData: { stepName: '', recommendType: null, quotationItem: '', personCount: 3 },
            secondQuotationFormData: { stepName: '' },
            smeFormData: { stepName: '', discount: null, discountType: null, overMaxScore: false },

            //表单验证规则（统一使用 formRules，弹窗中的表单验证规则保留以兼容模板引用）
            formRules: {
                stepName: [{ required: true, message: '请输入步骤名称' }]
            },
            scoringFormRules: {
                stepName: [{ required: true, message: '请输入步骤名称'}]
            },
            benchmarkFormRules: {
                stepName: [{ required: true, message: '请输入步骤名称'}]
            },
            scoringCalculationFormRules: {
                stepName: [{ required: true, message: '请输入步骤名称' }]
            },
            candidateFormRules: {
                stepName: [{ required: true, message: '请输入步骤名称' }]
            },
            secondQuotationFormRules: {
                stepName: [{ required: true, message: '请输入步骤名称'}]
            },
            smeFormRules: {
                stepName: [{ required: true, message: '请输入步骤名称' }]
            },
            // 记录步骤保存时间（用于排序）
            stepSaveOrder: {
                '01': 0, '02': 0, '03': 0, '04': 0, '05': 0, '0601': 0, '0602': 0
            },
            // 文档点击事件处理引用（用于关闭下拉菜单）
            documentClickHandler: null,
            // 模版数据
            templateList: [
                { id: 1, name: '综合评分法', type: 'comprehensive' },
                { id: 2, name: '最低评标价法', type: 'lowest' }
            ]
        }
    },
    computed: {
    },
    mounted() {
        this.getStepTypeList()// 获取步骤类型
        this.getSectionList()
        if (this.$route.query.bidSectionCode && this.$route.query.sectionId) {
            this.value = this.$route.query.bidSectionCode
            this.sectionId = this.$route.query.sectionId
            this.getStepListBySectionId()
            this.isSectionDropdownDisabled = true;
        }
        this.documentClickHandler = (event) => {
            this.handleClickOutside(event)
        }
        document.addEventListener('click', this.documentClickHandler)
        this.$nextTick(() => {
            this.clearStuckModalMask()
        })
        let _resizeTimer = null
        this._resizeHandler = () => {
            clearTimeout(_resizeTimer)
            _resizeTimer = setTimeout(() => { this.clearStuckModalMask() }, 300)
        }
        window.addEventListener('resize', this._resizeHandler)

    },
    beforeDestroy() {
        if (this.documentClickHandler) {
            document.removeEventListener('click', this.documentClickHandler)
            this.documentClickHandler = null
        }
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler)
            this._resizeHandler = null
        }
    },

    methods: {
        //复制之前的评标办法
        handleCopyStep(){
            this.copySearchKeyword = ''
            this.copyPagination = { current: 1, pageSize: 10, total: 0 }
            this.copyProjectList = []
            this.showCopyModal = true
            this.fetchProjectSectionList()
        },
        // 复制弹窗 - 拉取项目/标段列表
        fetchProjectSectionList(){
            this.copyLoading = true
            getProjectSectionList({
                channelCode: '',
                from: 0,
                pageIndex: this.copyPagination.current,
                pageSize: this.copyPagination.pageSize,
                projectName: this.copySearchKeyword || ''
            }).then(res => {
                this.copyLoading = false
                if (res.code === 200 && res.data) {
                    this.copyProjectList = res.data.records || []
                    this.copyPagination.total = res.data.total || 0
                } else {
                    this.copyProjectList = []
                    this.copyPagination.total = 0
                }
            }).catch(() => {
                this.copyLoading = false
                this.copyProjectList = []
                this.copyPagination.total = 0
            })
        },
        // 复制弹窗 - 搜索
        handleCopySearch(){
            this.copyPagination.current = 1
            this.fetchProjectSectionList()
        },
        // 复制弹窗 - 分页变化
        handleCopyPageChange(page){
            this.copyPagination.current = page
            this.fetchProjectSectionList()
        },
        // 复制弹窗 - 点击行内复制按钮
        handleCopyRow(project, section){
            //  二次确认
            this.$confirm('确定复制该标段吗？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '取消',
                type: 'warning',
                distinguishCancelAndClose: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
            }).then(() => {
                this.copyStep(section.sectionCode)
            }).catch(() => {
                // 用户取消操作
            })
        },

        copyStep(sectionCode){
            let data = {
                sectionCode:sectionCode
            }
            copyStep(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('复制成功')
                    this.getStepListBySectionId()
                    this.closeCopyModal()
                }
            }).catch(() => {
                this.$message.error('复制失败')
            })
        },




        // 复制弹窗 - 关闭
        closeCopyModal(){
            this.showCopyModal = false
            this.copyProjectList = []
            this.copySearchKeyword = ''
            this.copyPagination = { current: 1, pageSize: 10, total: 0 }
        },
        clearStuckModalMask() {
            const hasDialogOpen = this.showModal || this.showScoringModal || this.showBenchmarkModal ||
                this.showScoringCalculationModal || this.showCandidateModal ||
                this.showSecondQuotationModal || this.showSMEModal || this.showTemplateModal
            if (hasDialogOpen) return

            const wrappers = Array.from(document.querySelectorAll('.el-message-box__wrapper'))
            const hasVisibleMessageBox = wrappers.some(el => {
                const style = window.getComputedStyle(el)
                return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
            })
            if (hasVisibleMessageBox) return

            const dialogWrappers = Array.from(document.querySelectorAll('.el-dialog__wrapper'))
            const hasVisibleDialog = dialogWrappers.some(el => {
                const style = window.getComputedStyle(el)
                return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
            })
            if (hasVisibleDialog) return

            const modals = document.querySelectorAll('.v-modal')
            modals.forEach((modal) => {
                if (modal && modal.parentNode) {
                    modal.parentNode.removeChild(modal)
                }
            })
            document.body.classList.remove('v-modal-open')
            document.body.style.overflow = ''
            document.body.style.paddingRight = ''
            document.documentElement.classList.remove('v-modal-open')
        },
        // 返回上一页
        handleBack() {
            this.$router.back()
        },
        // 统一保存入口
        handleUnifiedSave() {
            this.saveStepSettings()
            // if (!this.currentStep) {
            //     this.$message.warning('请先选择一个评审步骤')
            //     return
            // }
            // const map = {
            //     '01': this.saveCurrentPassReviewStep,
            //     '02': this.saveCurrentScoreReviewStep,
            //     '03': this.saveCurrentBenchmarkStep,
            //     '04': this.saveCurrentScoringCalculationStep,
            //     '05': this.saveCurrentCandidateStep,
            //     '0601': this.saveCurrentSecondQuotationStep,
            //     '0602': this.saveCurrentSMEStep
            // }
            // const fn = map[this.stepTypeCode]
            // if (fn) {
            //     fn.call(this)
            // } else {
            //     this.$message.warning('当前步骤暂不支持保存')
            // }
        },
        // 处理下拉菜单命令
        handleDropdownCommand(command) {
            if (command === 'create') {
                this.handleCreateSteps()
            } else if (command === 'template') {
                // 使用模版创建
                this.showTemplateModal = true
            }
        },

        // 关闭模版选择弹窗
        closeTemplateModal() {
            this.showTemplateModal = false
            this.$nextTick(() => {
                this.clearStuckModalMask()
            })
        },

        // 使用模版
        handleUseTemplate(template) {
            if (this.leftSteps.length === 0) {
                if (template.type === 'comprehensive') {
                    // 综合评分法模版
                    this.createStepByModel(1)
                } else if (template.type === 'lowest') {
                    // 最低评标价法模版
                    this.createStepByModel(2)
                }
                this.showTemplateModal = false
                return
            }

            this.showTemplateModal = false
            this.$nextTick(() => {
                this.$confirm('使用模版会覆盖之前的评标方法，是否覆盖？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '取消',
                    type: 'warning',
                    distinguishCancelAndClose: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                }).then(() => {
                    if (template.type === 'comprehensive') {
                        // 综合评分法模版
                        this.createStepByModel(1)
                    } else {
                        // 最低评标价法模版
                        this.createStepByModel(2)
                    }
                }).catch(() => {
                    // 用户取消操作
                })
            })
        },

        raiseLatestConfirmLayer() {
            const applyLayer = () => {
                const wrappers = document.querySelectorAll('.el-message-box__wrapper')
                const latestWrapper = wrappers[wrappers.length - 1]
                if (latestWrapper) {
                    latestWrapper.style.setProperty('z-index', '10000', 'important')
                }
            }

            this.$nextTick(() => {
                applyLayer()
                setTimeout(applyLayer, 16)
                setTimeout(applyLayer, 80)
            })
        },

        async createStepByModel(modelType) {
            const res = await createStepByModel({
                sectionId: this.sectionId,
                sectionCode: this.value,
                projectId: this.projectId,
                modelType: modelType


            })
            if (res.code === 200) {
                this.getStepListBySectionId()
            } else {
                this.$message.error(res.msg)
            }

        },


        // 处理点击菜单外部关闭下拉菜单
        handleClickOutside(event) {
            if (!this.showDropdown) return
            const menuEl = this.$refs.dropdownMenu
            const btnRef = this.$refs.createStepBtn
            const btnEl = btnRef && (btnRef.$el || btnRef)
            const target = event.target
            if ((menuEl && menuEl.contains(target)) || (btnEl && btnEl.contains(target))) {
                return
            }
            this.showDropdown = false
        },

        // 获取标段信息   
        handleSectionChange(val) {
            const section = this.sectionList.find(s => s.bidSectionCode === val)
            if (!section) {
                this.$message.error('标段编码不存在')
                return
            }
            this.sectionId = section.id
            this.localStepOrder = null
            this.getStepListBySectionId()
            this.getSubmitStatus()

        },
        //获取提交状态
        async getSubmitStatus() {
            const res = await getSubmitStatus(this.sectionId)
            if (res.code === 200) {
                this.submitStatus = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        //根据项目编码获取标段列表
        async getSectionList() {
            const res = await getSectionList({
                projectCode: this.projectCode
            })
            if (res.code === 200) {
                this.sectionList = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        // 根据标段id获取步骤列表
        async getStepListBySectionId() {
            try {
                const res = await getStepListBySectionId({
                    sectionId: this.sectionId
                })
                if (res.code === 200) {
                    const list = res.data || []
                    if (this.localStepOrder && this.localStepOrder.length > 0) {
                        const orderIndex = {}
                        this.localStepOrder.forEach((id, i) => { orderIndex[id] = i })
                        this.leftSteps = list.slice().sort((a, b) => {
                            const ai = orderIndex[a.id] !== undefined ? orderIndex[a.id] : 9999
                            const bi = orderIndex[b.id] !== undefined ? orderIndex[b.id] : 9999
                            return ai !== bi ? ai - bi : (Number(a.orderNum) || 0) - (Number(b.orderNum) || 0)
                        })
                        this.leftSteps.forEach((s, i) => { s.orderNum = i + 1 })
                    } else {
                        this.leftSteps = list.slice().sort((a, b) => (Number(a.orderNum) || 0) - (Number(b.orderNum) || 0))
                    }
                    this.updateStepOrderNum()
                } else {
                    this.$message.error(res.msg)
                }
            } finally {
                this.$nextTick(() => {
                    this.clearStuckModalMask()
                })
            }
        },
        // 更新 stepOrderNum：取最后一项的 orderNum + 1，为空则为 1
        updateStepOrderNum() {
            if (this.leftSteps.length > 0) {
                const lastStep = this.leftSteps[this.leftSteps.length - 1]
                this.stepOrderNum = (lastStep.orderNum || 0) + 1
            } else {
                this.stepOrderNum = 1
            }
        },
        getLiveOrderNum() {
            if (this.currentStep) {
                const found = this.leftSteps.find(s => s.id === this.currentStep)
                if (found && Number(found.orderNum) > 0) return Number(found.orderNum)
            }
            return Number(this.stepOrderNum) || 1
        },
        // 删除步骤事件
        delStepEvent(stepId) {
            this.$confirm('确定要删除该步骤吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 调用删除接口
                this.delStep(stepId)
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        // 删除步骤接口
        async delStep(stepId) {
            const res = await delStep({
                stepId: stepId
            })
            if (res.code === 200) {
                // 如果删除的是当前选中的步骤，清除右侧选中状态
                if (this.currentStep === stepId) {
                    this.currentStep = null
                    this.currentStepName = ''
                    this.currentStepData = null
                    this.stepTypeCode = ''
                }
                this.getStepListBySectionId()
                this.$message.success('删除成功')
            } else {
                this.$message.error(res.msg)
            }
        },
        //编辑步骤接口
        async editStep(stepId) {
            const res = await editStep({
                stepId: stepId
            })
            if (res.code === 200) {
                this.getStepListBySectionId()
                this.$message.success('编辑成功')
            } else {
                this.$message.error(res.msg)
            }
        },
        // 获取步骤类型
        async getStepTypeList() {
            const res = await getStepTypeList()
            if (res.code === 200) {
                this.stepTypeList = Array.isArray(res.data) ? res.data : []
            } else {
                this.$message.error(res.msg)
            }
        },
        // 通过式评审步骤保存
        saveReviewStep() {
            this.$refs.reviewForm.validate(async (valid) => {
                if (valid) {
                    // 验证评审项
                    for (let item of this.formData.reviewItems) {
                        if (!String(item.reviewName || '').trim()) {
                            this.$message.error('请完善所有评审项名称')
                            return
                        }
                    }
                    // 调用通过式评审保存接口
                    await this.savePassReviewStep()
                } else {
                    this.$message.error('请完善表单信息')
                }
            }, (error) => {

            })
        },
        // 通过式评审步骤保存接口
        async savePassReviewStep() {
            // 步骤序号自增
            this.stepOrderNum++
            // 构建保存参数
            const payload = {
                // 步骤序号（从1开始）
                orderNum: this.stepOrderNum,
                // 项目id
                projectId: this.projectId,
                // 标段编码（当前选中的标段）
                sectionCode: this.value,
                // 标段id
                sectionId: this.sectionId,
                // 步骤名称
                stepName: this.formData.stepName,
                // 暗标评审（0：明标、1：暗标）
                isBlindReview: this.formData.isBlindReview ?? 0,
                // 步骤类型编码
                stepTypeCode: this.currentStepTypeInfo?.stepTypeCode || '01',
                // 绑定的步骤id（步骤类型的id）
                bindStepId: this.currentStepTypeInfo?.bindStepId || 1,
                // 评审项列表
                itemList: this.formData.reviewItems.map(item => ({
                    id: item.id,
                    reviewName: item.reviewName,
                    reviewStandard: item.reviewStandard
                })),
            }
            try {
                const res = await addPassReview(payload)
                if (res && res.code === 200) {
                    this.$message.success('保存成功')
                    this.showModal = false
                    this.stepSaveOrder['01'] = Date.now()
                    this.getStepListBySectionId()
                    this.getSubmitStatus()
                } else {
                    this.stepOrderNum--
                    this.$message.error((res && res.msg) || '保存失败')
                }
            } catch (e) {
                this.stepOrderNum--
                this.$message.error('保存失败')
                console.error('通过式评审保存失败:', e)
            }
        },
        // 编辑场景：保存当前右侧通过式评审步骤
        saveCurrentPassReviewStep() {
            // 仅在已选中步骤且为通过式评审时生效
            if (!this.currentStep || this.stepTypeCode !== '01' || !this.currentStepData) return
            this.$refs.rightReviewForm && this.$refs.rightReviewForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const reviewItems = this.currentStepData.reviewItems || []
                for (let item of reviewItems) {
                    if (!String(item.reviewName || '').trim()) {
                        this.$message.error('请完善所有评审项名称')
                        return
                    }
                }
                // 使用当前步骤数据组装编辑 payload
                const payload = {
                    orderNum: this.getLiveOrderNum(),
                    projectId: this.projectId,
                    sectionCode: this.currentStepData.sectionCode || this.value,
                    sectionId: this.currentStepData.sectionId || this.sectionId,
                    stepName: this.currentStepData.stepName,
                    isBlindReview: this.currentStepData.isBlindReview ?? 0,
                    stepTypeCode: this.stepTypeCode || '01',
                    bindStepId: this.currentStepData.bindStepId || 1,
                    stepId: this.currentStepData.stepId || this.currentStep,
                    itemList: reviewItems.map(item => ({
                        id: item.id,
                        stepId: this.currentStepData.stepId || this.currentStep,
                        reviewName: item.reviewName,
                        reviewStandard: item.reviewStandard
                    })),
                }
                try {
                    const res = await addPassReview(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepListBySectionId()
                        this.getStepDetailByStepId(this.currentStep)
                        this.getSubmitStatus()
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('通过式评审编辑保存失败:', e)
                }
            })
        },

        // 编辑场景：保存当前右侧小微企业认证步骤
        saveCurrentSMEStep() {
            if (!this.currentStep || this.stepTypeCode !== '0602' || !this.currentStepData) return
            // 额外检查必填字段
            if (this.currentStepData.discount === null || this.currentStepData.discount === undefined) {
                this.$message.error('请输入优惠幅度')
                return
            }
            this.$refs.rightSmeForm && this.$refs.rightSmeForm.validate().then(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const data = this.currentStepData
                const payload = {
                    sectionCode: data.sectionCode || this.value,
                    sectionId: data.sectionId || this.sectionId,
                    stepName: data.stepName,
                    stepTypeCode: this.stepTypeCode || '0602',
                    orderNum: this.getLiveOrderNum(),
                    projectId: this.projectId,
                    optionalType: 2,
                    stepId: data.stepId || this.currentStep,
                    ...data,
                }
                try {
                    const res = await saveOptionalStep(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepListBySectionId()
                        this.getStepDetailByStepId(this.currentStep)
                        this.getSubmitStatus()
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('小微企业认证编辑保存失败:', e)
                }
            })
        },
        // 编辑场景：保存当前右侧打分式评审步骤
        saveCurrentScoreReviewStep() {
            if (!this.currentStep || this.stepTypeCode !== '02' || !this.currentStepData) return
            this.$refs.rightScoringReviewForm && this.$refs.rightScoringReviewForm.validate().then(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const data = this.currentStepData

                const scoreReviewList = data.scoreReviewList || []
                for (let item of scoreReviewList) {
                    if (!String(item.reviewName || '').trim() || !String(item.reviewStandard || '').trim()) {
                        this.$message.error('请完善所有打分评审项信息')
                        return
                    }
                }

                // 校验分数范围总和是否等于步骤最高分
                const totalMaxScore = this.calcScoreRangeMaxSum(scoreReviewList)
                if (totalMaxScore !== data.score) {
                    this.$message.error(`分数不一致：评审项最高分总和为 ${totalMaxScore}，步骤最高分为 ${data.score}`)
                    return
                }

                const payload = {
                    addUpScore: data.addUpScore,
                    bidPersonCount: data.bidPersonCount,
                    bindStepId: data.bindStepId || this.currentStepTypeInfo?.bindStepId,
                    followUpCount: data.followUpCount,
                    followUpSetting: data.followUpSetting,
                    lastScoreSetting: data.lastScoreSetting,
                    maxScoreCount: data.maxScoreCount,
                    minScoreCount: data.minScoreCount,
                    orderNum: this.getLiveOrderNum(),
                    percent: data.percent,
                    projectId: this.projectId,
                    score: data.score,
                    scoreReasonType: data.scoreReasonType,
                    scoreReviewList: scoreReviewList.map(item => ({
                        stepId: data.stepId || this.currentStep,
                        id: item.id,
                        reviewName: item.reviewName,
                        reviewStandard: item.reviewStandard,
                        scoreRange: item.scoreRange,
                        scoreType: item.scoreType
                    })),
                    scoreType: data.scoreType,
                    sectionCode: data.sectionCode || this.value,
                    sectionId: data.sectionId || this.sectionId,
                    skipStep: data.skipStep,
                    stepMarkType: data.stepMarkType,
                    stepName: data.stepName,
                    isBlindReview: data.isBlindReview ?? 0,
                    stepTypeCode: this.stepTypeCode || '02',
                    stepId: data.stepId || this.currentStep,
                }
                try {
                    const res = await addScoreReview(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepListBySectionId()
                        this.getStepDetailByStepId(this.currentStep)
                        this.getSubmitStatus()
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('打分式评审编辑保存失败:', e)
                }
            }).catch(() => {
                this.$message.error('请完善表单信息')
            })
        },
        // 打分式评审步骤保存
        saveScoringReviewStep() {
            this.$refs.scoringReviewForm && this.$refs.scoringReviewForm.validate().then((valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }

                const scoreReviewList = this.scoringFormData.scoreReviewList || []
                // 校验分数范围总和是否等于步骤最高分
                const totalMaxScore = this.calcScoreRangeMaxSum(scoreReviewList)
                if (totalMaxScore !== this.scoringFormData.score) {
                    this.$message.error(`分数不一致：评审项最高分总和为 ${totalMaxScore}，步骤最高分为 ${this.scoringFormData.score}`)
                    return
                }

                this.saveScoreReviewStep()
            }).catch(() => {
                this.$message.error('请完善表单信息')
            })
        },
        //打分式评审步骤接口
        async saveScoreReviewStep() {
            this.stepOrderNum++
            const payload = {
                addUpScore: this.scoringFormData.addUpScore,
                bidPersonCount: this.scoringFormData.bidPersonCount,
                bindStepId: this.currentStepTypeInfo?.bindStepId,
                followUpCount: this.scoringFormData.followUpCount,
                followUpSetting: this.scoringFormData.followUpSetting,
                lastScoreSetting: this.scoringFormData.lastScoreSetting,
                maxScoreCount: this.scoringFormData.maxScoreCount,
                minScoreCount: this.scoringFormData.minScoreCount,
                orderNum: this.stepOrderNum,
                percent: this.scoringFormData.percent,
                projectId: this.projectId,
                score: this.scoringFormData.score,
                scoreReasonType: this.scoringFormData.scoreReasonType,
                scoreReviewList: this.scoringFormData.scoreReviewList.map(item => ({
                    reviewName: item.reviewName,
                    reviewStandard: item.reviewStandard,
                    scoreRange: item.scoreRange,
                    scoreType: item.scoreType
                })),
                scoreType: this.scoringFormData.scoreType,
                sectionCode: this.value,
                sectionId: this.sectionId,
                skipStep: this.scoringFormData.skipStep,
                stepMarkType: this.scoringFormData.stepMarkType,
                stepName: this.scoringFormData.stepName,
                isBlindReview: this.scoringFormData.isBlindReview ?? 0,
                stepTypeCode: this.currentStepTypeInfo?.stepTypeCode,
            }
            console.log(JSON.stringify(payload))
            try {
                await addScoreReview(payload).then(res => {
                    if (res.code === 200) {
                        this.$message.success('保存成功')
                        this.showScoringModal = false
                        this.stepSaveOrder['02'] = Date.now()
                        this.getStepListBySectionId()
                        this.getSubmitStatus()
                    } else {
                        this.stepOrderNum--
                        this.$message.error(res.msg)
                    }
                })
            } catch (e) {
                this.stepOrderNum--
                this.$message.error('保存失败')
                console.error('打分式评审保存失败:', e)
            }

        },
        // 计算 scoreReviewList 中所有 scoreRange 的最大分总和
        calcScoreRangeMaxSum(scoreReviewList) {
            if (!Array.isArray(scoreReviewList) || scoreReviewList.length === 0) {
                return 0
            }
            let total = 0
            for (const item of scoreReviewList) {
                const range = item.scoreRange
                if (!range || typeof range !== 'string') continue
                const trimmed = range.trim()
                if (!trimmed) continue
                // 按逗号分割，每个部分可能是"纯数字"或"数字-数字"
                const parts = trimmed.split(',')
                let maxInThisRange = 0
                for (const part of parts) {
                    if (part.includes('-')) {
                        // 区间格式：取结束分（较大值）
                        const [startStr, endStr] = part.split('-')
                        const end = parseInt(endStr, 10)
                        if (!isNaN(end) && end > maxInThisRange) {
                            maxInThisRange = end
                        }
                    } else {
                        // 固定分格式
                        const num = parseInt(part, 10)
                        if (!isNaN(num) && num > maxInThisRange) {
                            maxInThisRange = num
                        }
                    }
                }
                total += maxInThisRange
            }
            return total
        },
        // 保存基准价设置
        saveBenchmarkStep() {
            this.$refs.benchmarkPriceForm && this.$refs.benchmarkPriceForm.validate().then((valid) => {
                if (valid) {
                    this.saveBasePrice()
                } else {
                    this.$message.error('请完善表单信息')
                }
            })
        },
        // 编辑场景：保存当前右侧计算基准价步骤
        saveCurrentBenchmarkStep() {
            if (!this.currentStep || this.stepTypeCode !== '03' || !this.currentStepData) return

            this.$refs.rightBenchmarkForm && this.$refs.rightBenchmarkForm.validate().then(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const data = this.currentStepData
                const { calculateType } = data
                let subFormData = {}

                if (calculateType === 1) {
                    subFormData = data.manualCalculation || {}
                } else if (calculateType === 2) {
                    subFormData = data.lowestPriceCalculation || {}
                } else if (calculateType === 3) {
                    subFormData = data.averagePriceCalculation || {}
                } else if (calculateType === 4) {
                    const highestLimitForm = data.highestLimitPriceCalculation || {}
                    const { enableConditionalRule, ...restHighestLimit } = highestLimitForm
                    subFormData = {
                        ...restHighestLimit,
                        personSelect: enableConditionalRule ? 1 : 0
                    }
                }

                if (calculateType === 1 || calculateType === 2) {
                    const { removeItemList, ...rest } = subFormData
                    subFormData = rest
                }

                const payload = {
                    sectionCode: data.sectionCode || this.value,
                    sectionId: data.sectionId || this.sectionId,
                    stepName: data.stepName,
                    stepTypeCode: this.stepTypeCode || '03',
                    calculateType,
                    ...subFormData,
                    orderNum: this.getLiveOrderNum(),
                    projectId: this.projectId,
                    stepId: data.stepId || this.currentStep,
                }

                try {
                    const res = await saveBasePrice(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepListBySectionId()
                        this.getSubmitStatus()
                        this.getStepDetailByStepId(this.currentStep)
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('计算基准价编辑保存失败:', e)
                }
            })
        },
        // 计算基准价接口
        async saveBasePrice() {
            this.stepOrderNum++
            // 根据 calculateType 获取对应的子表单数据并解构
            const { stepName, calculateType } = this.benchmarkFormData
            let subFormData = {}

            if (calculateType === 1) {
                // 手工计算
                subFormData = this.benchmarkFormData.manualCalculation || {}
            } else if (calculateType === 2) {
                // 最低价
                subFormData = this.benchmarkFormData.lowestPriceCalculation || {}
            } else if (calculateType === 3) {
                // 平均值 (personSelect: 1启用, 0不启用; description: 抽取规则描述)
                subFormData = this.benchmarkFormData.averagePriceCalculation || {}
            } else if (calculateType === 4) {
                // 最高限价 (参考平均值模式，对应 personSelect 与 description)
                const highestLimitForm = this.benchmarkFormData.highestLimitPriceCalculation || {}
                const { enableConditionalRule, ...restHighestLimit } = highestLimitForm
                subFormData = {
                    ...restHighestLimit,
                    // 将表单中的布尔开关映射为后端需要的 personSelect: 1 启用, 0 不启用
                    personSelect: enableConditionalRule ? 1 : 0
                }
            }
            // 如果是手工计算或最低价，不需要 removeItemList，删除该字段
            if (calculateType === 1 || calculateType === 2) {
                const { removeItemList, ...rest } = subFormData
                subFormData = rest
            }
            this.benchmarkFormData = {
                stepName,
                calculateType,
                ...subFormData
            }
            const payload = {
                sectionCode: this.value,
                sectionId: this.sectionId,
                stepName: this.benchmarkFormData.stepName,
                stepTypeCode: this.currentStepTypeInfo?.stepTypeCode,
                calculateType,
                ...subFormData,
                orderNum: this.stepOrderNum,
                projectId: this.projectId,
            }

            try {
                await saveBasePrice(payload).then(res => {
                    if (res.code === 200) {
                        this.$message.success('保存成功')
                        this.showBenchmarkModal = false
                        this.stepSaveOrder['03'] = Date.now()
                        this.getStepListBySectionId()
                        this.getSubmitStatus()
                    } else {
                        this.stepOrderNum--
                        this.$message.error(res.msg)
                    }
                })
            } catch (e) {
                this.stepOrderNum--
                this.$message.error('保存失败')
                console.error('保存基准价设置失败:', e)
            }

        },
        // 保存计算报价得分设置
        saveScoringCalculationStep() {
            this.$refs.scoringCalculationForm && this.$refs.scoringCalculationForm.validate().then((valid) => {
                if (valid) {
                    this.saveQuotationScoreStep()

                } else {
                    this.$message.error('请完善表单信息')
                }
            })
        },
        // 编辑场景：保存当前右侧计算报价得分步骤
        saveCurrentScoringCalculationStep() {
            if (!this.currentStep || this.stepTypeCode !== '04' || !this.currentStepData) return
            this.$refs.rightScoringCalculationForm && this.$refs.rightScoringCalculationForm.validate().then(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const data = this.currentStepData
                const { calculateMethod } = data
                let subFormData = {}

                if (calculateMethod === 1) {
                    subFormData = data.deviationRateScoring || {}
                } else if (calculateMethod === 2) {
                    subFormData = data.manualCalculationScoring || {}
                } else if (calculateMethod === 3) {
                    subFormData = data.standardQuoteScoring || {}
                }
                const { quotationItem, ...restSubForm } = subFormData
                const bindStepId = quotationItem
                const payload = {
                    sectionCode: data.sectionCode || this.value,
                    sectionId: data.sectionId || this.sectionId,
                    stepName: data.stepName,
                    stepTypeCode: this.stepTypeCode || '04',
                    calculateMethod,
                    bindStepId,
                    ...restSubForm,
                    orderNum: this.getLiveOrderNum(),
                    projectId: this.projectId,
                    stepId: data.stepId || this.currentStep,
                }
                try {
                    const res = await saveQuotationScoreStep(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepListBySectionId()
                        this.getStepDetailByStepId(this.currentStep)
                        this.getSubmitStatus()
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('计算报价得分编辑保存失败:', e)
                }
            })
        },
        // 保存计算报价得分设置接口  
        async saveQuotationScoreStep() {
            this.stepOrderNum++
            const { stepName, calculateMethod } = this.scoringCalculationFormData
            let subFormData = {}
            if (calculateMethod === 1) {
                // 1 偏差率模式
                subFormData = this.scoringCalculationFormData.deviationRateScoring || {}
            } else if (calculateMethod === 2) {
                // 2 手工计算模式
                subFormData = this.scoringCalculationFormData.manualCalculationScoring || {}
            } else if (calculateMethod === 3) {
                // 3 基准价/报价*标准分模式
                subFormData = this.scoringCalculationFormData.standardQuoteScoring || {}
            }
            // 报价分采用的基准价：表单里用 quotationItem 选中基准价步骤，这里统一转换为 bindStepId 提交
            const { quotationItem, ...restSubForm } = subFormData
            const bindStepId = quotationItem
            this.scoringCalculationFormData = {
                stepName,
                calculateMethod,
                ...subFormData
            }
            const payload = {
                sectionCode: this.value,
                sectionId: this.sectionId,
                stepName: this.scoringCalculationFormData.stepName,
                stepTypeCode: this.currentStepTypeInfo?.stepTypeCode,
                calculateMethod,
                bindStepId,
                ...restSubForm,
                orderNum: this.stepOrderNum,
                projectId: this.projectId,
            }
            console.log(JSON.stringify(payload));
            await saveQuotationScoreStep(payload).then(res => {
                if (res.code === 200) {
                    this.$message.success('保存成功')
                    this.showScoringCalculationModal = false
                    this.stepSaveOrder['04'] = Date.now()
                    this.getStepListBySectionId()
                    this.getSubmitStatus()
                } else {
                    this.stepOrderNum--
                    this.$message.error(res.msg)
                }
            })
        },
        // 保存推荐候选人设置
        saveCandidateStep() {
            this.$refs.candidateForm && this.$refs.candidateForm.validate().then((valid) => {
                if (valid) {
                    this.saveRecommendStep()
                } else {
                    this.$message.error('请完善表单信息')
                }
            })
        },
        // 编辑场景：保存当前右侧推荐候选人步骤
        saveCurrentCandidateStep() {
            if (!this.currentStep || this.stepTypeCode !== '05' || !this.currentStepData) return

            this.$refs.rightCandidateForm && this.$refs.rightCandidateForm.validate().then(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const data = this.currentStepData
                const { recommendType, personCount, quotationItem } = data
                const payload = {
                    sectionCode: data.sectionCode || this.value,
                    sectionId: data.sectionId || this.sectionId,
                    stepName: data.stepName,
                    stepTypeCode: this.stepTypeCode || '05',
                    recommendType,
                    personCount,
                    ...(recommendType === 2 ? { quotationItem } : {}),
                    orderNum: this.getLiveOrderNum(),
                    projectId: this.projectId,
                    stepId: data.stepId || this.currentStep,
                }
                try {
                    const res = await saveRecommendStep(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepDetailByStepId(this.currentStep)
                        this.getStepListBySectionId()
                        this.getSubmitStatus()
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('推荐候选人编辑保存失败:', e)
                }
            })
        },
        // 添加推荐候选人接口
        async saveRecommendStep() {
            this.stepOrderNum++
            const { stepName, recommendType, personCount, quotationItem } = this.candidateFormData
            let formData = { stepName, recommendType, personCount }
            if (recommendType === 2) {
                // 最低标价法：需要 quotationItem
                formData.quotationItem = quotationItem
            }
            this.candidateFormData = formData
            const payload = {
                sectionCode: this.value,
                sectionId: this.sectionId,
                stepName,
                stepTypeCode: this.currentStepTypeInfo?.stepTypeCode,
                recommendType,
                personCount,
                ...(recommendType === 2 ? { quotationItem } : {}),
                orderNum: this.stepOrderNum,
                projectId: this.projectId
            }
            await saveRecommendStep(payload).then(res => {
                if (res.code === 200) {
                    this.$message.success('保存成功')
                    this.showCandidateModal = false
                    this.stepSaveOrder['05'] = Date.now()
                    this.getStepListBySectionId()
                    this.getSubmitStatus()
                } else {
                    this.stepOrderNum--
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.stepOrderNum--
            })
        },
        // 保存二次报价环节设置
        saveSecondQuotationStep() {
            this.$refs.secondQuotationForm && this.$refs.secondQuotationForm.validate().then((valid) => {
                if (valid) {
                    this.saveOptionalStep(1)
                } else {
                    this.$message.error('请完善表单信息')
                }
            })
        },
        // 编辑场景：保存当前右侧二次报价步骤
        saveCurrentSecondQuotationStep() {
            if (!this.currentStep || this.stepTypeCode !== '0601' || !this.currentStepData) return
            
            this.$refs.rightSecondQuotationForm && this.$refs.rightSecondQuotationForm.validate().then(async (valid) => {
                if (!valid) {
                    this.$message.error('请完善表单信息')
                    return
                }
                const data = this.currentStepData
                const payload = {
                    sectionCode: data.sectionCode || this.value,
                    sectionId: data.sectionId || this.sectionId,
                    stepName: data.stepName,
                    stepTypeCode: this.stepTypeCode || '0601',
                    orderNum: this.getLiveOrderNum(),
                    projectId: this.projectId,
                    optionalType: 1,
                    stepId: data.stepId || this.currentStep,
                }
                try {
                    const res = await saveOptionalStep(payload)
                    if (res && res.code === 200) {
                        this.$message.success('保存成功')
                        this.getStepListBySectionId()
                        this.getStepDetailByStepId(this.currentStep)
                        this.getSubmitStatus()
                    } else {
                        this.$message.error((res && res.msg) || '保存失败')
                    }
                } catch (e) {
                    this.$message.error('保存失败')
                    console.error('二次报价编辑保存失败:', e)
                }
            })
        },
        //小微认证
        saveSMEModal() {
            this.$refs.smeForm && this.$refs.smeForm.validate().then((valid) => {
                if (valid) {
                    this.saveOptionalStep(2)
                } else {
                    this.$message.error('请完善表单信息')
                }
            })
        },
        // 保存可选步骤接口
        async saveOptionalStep(vl) {
            this.stepOrderNum++
            let payload = {}
            //  如果是 二次报价
            if (vl === 1) {
                payload = {
                    sectionCode: this.value,
                    sectionId: this.sectionId,
                    stepName: this.secondQuotationFormData.stepName,
                    stepTypeCode: this.currentStepTypeInfo?.stepTypeCode,
                    orderNum: this.stepOrderNum,
                    projectId: this.projectId,
                    optionalType: 1
                }
            } else {
                payload = {
                    sectionCode: this.value,
                    sectionId: this.sectionId,
                    stepName: this.smeFormData.stepName,
                    stepTypeCode: this.currentStepTypeInfo?.stepTypeCode,
                    orderNum: this.stepOrderNum,
                    projectId: this.projectId,
                    optionalType: 2,
                    ...this.smeFormData
                }
            }
            await saveOptionalStep(payload).then(res => {
                if (res.code === 200) {
                    if (vl === 1) {
                        this.stepSaveOrder['0601'] = Date.now()
                        this.showSecondQuotationModal = false
                    } else {
                        this.stepSaveOrder['0602'] = Date.now()
                        this.showSMEModal = false
                    }
                    this.$message.success('保存成功')
                    this.getStepListBySectionId()
                    this.getSubmitStatus()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 拖拽开始，记录源索引
        handleDragStart(step) {
            this.dragSourceIndex = this.leftSteps.findIndex(s => s.id === step.id)
        },
        // 放下时，按目标索引插入
        handleDrop(step) {
            if (this.dragSourceIndex === null) return
            const targetIndex = this.leftSteps.findIndex(s => s.id === step.id)
            if (targetIndex === -1 || targetIndex === this.dragSourceIndex) {
                this.dragSourceIndex = null
                return
            }
            const sourceStep = this.leftSteps[this.dragSourceIndex]
            const targetStep = this.leftSteps[targetIndex]
            if (sourceStep && targetStep) {
                const tmpOrder = sourceStep.orderNum
                sourceStep.orderNum = targetStep.orderNum
                targetStep.orderNum = tmpOrder
            }
            const moved = this.leftSteps.splice(this.dragSourceIndex, 1)[0]
            this.leftSteps.splice(targetIndex, 0, moved)
            // 根据当前顺序，重置所有步骤的 orderNum（从 1 开始递增）
            this.leftSteps.forEach((s, index) => {
                s.orderNum = index + 1
            })
            this.localStepOrder = this.leftSteps.map(s => s.id)
            this.dragSourceIndex = null
        },

        // 创建步骤
        handleCreateSteps() {
            this.showDropdown = !this.showDropdown
        },
        // 处理下拉菜单项点击
        handleDropdownItem(item) {
            this.showDropdown = false
            if (item === '通过式评审') {
                this.showModal = true
            } else if (item === '打分式评审') {
                this.showScoringModal = true
            } else if (item === '计算基准价') {
                this.showBenchmarkModal = true
            } else if (item === '计算报价得分') {
                this.showScoringCalculationModal = true
            } else if (item === '推荐候选人') {
                this.showCandidateModal = true
            } else if (item === '二次报价环节') {
                this.showSecondQuotationModal = true
            } else if (item === '小微企业认证环节') {
                this.showSMEModal = true
            }
            else {
                this.$message.success(`已选择1: ${item}`)
            }
        },

        // ========== 左侧步骤点击 & 右侧详情加载 ==========

        // 点击左侧步骤项
        handleStepClick(step) {
            this.currentStep = step.id
            this.stepTypeCode = step.stepTypeCode
            this.currentStepName = step.stepName || `步骤${step.id}`
            this.getStepDetailByStepId(step.id)
        },

        // 获取步骤详情并赋值给右侧表单
        async getStepDetailByStepId(stepId) {
            try {
                const res = await getStepDetailByStepId({ stepId })
                if (res.code === 200) {
                    const data = res.data || {}
                    let rule = data.rule
                    if (typeof rule === 'string') {
                        try { rule = JSON.parse(rule) } catch (e) { rule = {} }
                    }
                    rule = rule || {}

                    // 设置子类型（用于区分03/04/05下的不同表单）
                    this.ruleMethod = rule.method || null
                    // 转换数据格式并赋值给右侧表单
                    this.currentStepData = this.transformStepData(data, rule)
                    this.currentStepName = data.stepName
                } else {
                    this.$message.error(res.msg)
                }
            } catch (e) {
                console.error('获取步骤详情失败:', e)
                this.$message.error('获取步骤详情失败')
            } finally {
                this.$nextTick(() => {
                    this.clearStuckModalMask()
                })
            }
        },

        /**
         * 根据 stepTypeCode 转换接口数据为表单所需格式
         *   stepTypeCode 说明:
         *   01: 通过式评审 - 数据在 itemList
         *   02: 打分式评审 - 数据在 rule + itemList
         *   03: 计算基准价 - 数据在 rule，method: 1手工计算 2最低价 3平均值 4最高限价
         *   04: 计算报价得分 - 数据在 rule，method: 1偏差率 2手工计算 3基准价/报价*标准分
         *   05: 推荐候选人 - 数据在 rule，method: 1综合评分法 2最低标价法
         *   0601: 二次报价环节
         *   0602: 小微企业认证环节
         */
        transformStepData(data, rule) {
            const stepTypeCode = data.stepTypeCode || this.stepTypeCode
            const itemList = data.itemList || []

            // 基础数据
            const baseData = {
                stepId: data.stepId,
                stepName: data.stepName,
                sectionId: data.sectionId,
                sectionCode: data.sectionCode,
                orderNum: data.orderNum,
                bindStepId: data.bindStepId
            }

            switch (stepTypeCode) {
                case '01': // 通过式评审
                    return {
                        ...baseData,
                        isBlindReview: data.isBlindReview ?? 0,
                        // 转换 itemList 为 reviewItems 格式
                        reviewItems: itemList.map((item, index) => ({
                            id: item.id,
                            reviewName: item.reviewName || '',
                            reviewStandard: item.reviewStandard || ''
                        }))
                    }

                case '02': // 打分式评审
                    return {
                        ...baseData,
                        isBlindReview: data.isBlindReview ?? 0,
                        score: rule.score ?? 100,
                        scoreType: rule.scoreType ?? 1,
                        addUpScore: rule.addUpScore ?? false,
                        maxScoreCount: rule.maxScoreCount ?? 0,
                        minScoreCount: rule.minScoreCount ?? 0,
                        stepMarkType: data.stepMarkType ?? rule.stepMarkType ?? 1,  // 1=明标, 2=暗标
                        lastScoreSetting: rule.lastScoreSetting ?? 1,
                        followUpSetting: rule.followUpSetting ?? 1,
                        followUpCount: rule.followUpCount ?? 1,
                        thresholdScore: rule.thresholdScore ?? 90,
                        skipStep: rule.skipStep ?? false,
                        bidPersonCount: rule.bidPersonCount ?? 0,
                        scoreReasonType: rule.scoreReasonType ?? '0',
                        percent: rule.percent ?? 0,
                        // 转换 itemList 为 scoreReviewList 格式
                        scoreReviewList: itemList.length > 0 ? itemList.map((item, index) => ({
                            id: item.id || index + 1,
                            reviewName: item.reviewName || '',
                            reviewStandard: item.reviewStandard || '',
                            scoreRange: item.scoreRange || '',
                            scoreType: item.scoreType || '1'
                        })) : [{ id: 1, reviewName: '', reviewStandard: '', scoreRange: '', scoreType: '1' }]
                    }

                case '03': // 计算基准价
                    // 根据 method 将数据放到对应的嵌套对象中
                    const method03 = rule.method ?? null
                    // openingListId 转为字符串（与 quoteItemList 的 id 类型一致），映射为 quotationItem
                    const quotationItem03 = rule.openingListId != null ? String(rule.openingListId) : null
                    const result03 = {
                        ...baseData,
                        calculateType: method03,
                        manualCalculation: { quotationItem: null, description: '' },
                        lowestPriceCalculation: { quotationItem: null, personSelect: 0, bidPersonCount: 1, description: '' },
                        averagePriceCalculation: { quotationItem: null, personSelect: 0, bidPersonCount: 1, removeItemList: [], description: '' },
                        highestLimitPriceCalculation: { quotationItem: null, personSelect: 0, bidPersonCount: 1, removeItemList: [], description: '', minBidPriceMultiple: 0.80, maxBidPriceMultiple: 1.00, standardBidPriceMultiple: 0.80 }
                    }
                    // 根据 method 填充对应的子对象
                    if (method03 === 1) {
                        result03.manualCalculation = { quotationItem: quotationItem03, description: rule.description ?? '' }
                    } else if (method03 === 2) {
                        result03.lowestPriceCalculation = { quotationItem: quotationItem03, personSelect: rule.personSelect ?? 0, bidPersonCount: rule.bidPersonCount ?? 1, description: rule.description ?? '' }
                    } else if (method03 === 3) {
                        // personSelect: 1启用, 0不启用; 抽取规则描述使用 description 字段
                        // 最高报价和最低报价去除设置使用 itemList
                        result03.averagePriceCalculation = {
                            quotationItem: quotationItem03,
                            personSelect: rule.personSelect ?? 0,
                            bidPersonCount: rule.bidPersonCount ?? 1,
                            description: rule.description ?? '',
                            removeItemList: itemList ?? []
                        }
                    } else if (method03 === 4) {
                        result03.highestLimitPriceCalculation = {
                            quotationItem: quotationItem03,
                            personSelect: rule.personSelect ?? 0,
                            bidPersonCount: rule.bidPersonCount ?? 1,
                            description: rule.description ?? '',
                            removeItemList: itemList ?? [],
                            minBidPriceMultiple: rule.minBidPriceMultiple ?? 0.80,
                            maxBidPriceMultiple: rule.maxBidPriceMultiple ?? 1.00,
                            standardBidPriceMultiple: rule.standardBidPriceMultiple ?? 0.80
                        }
                    }
                    return result03

                case '04': // 计算报价得分
                    const method04 = rule.method ?? rule.calculateMethod ?? null
                    const quotationItem04 = data.bindStepId != null && data.bindStepId !== undefined
                        ? String(data.bindStepId)
                        : rule.quotationItem != null && rule.quotationItem !== undefined
                            ? String(rule.quotationItem)
                            : null

                    const result04 = {
                        ...baseData,
                        calculateMethod: method04,
                        deviationRateScoring: {
                            quotationItem: null,
                            calculateType: 1,
                            quoteLowBasePrice: 0,
                            quoteLowPricePercent: 0.00,
                            quoteLowScore: 0.00,
                            bidPriceIncreasePercent: 1.00,
                            bidPriceIncreaseCal: 2,
                            bidPriceIncreaseScore: 0,
                            bidPriceReducePercent: 1.00,
                            bidPriceReduceCal: 1,
                            bidPriceReduceScore: 0,
                            priceEqStandardScore: 100.00,
                            minPriceScore: 0.00,
                            maxPriceScore: 100.00,
                            description: '',
                            standardScore: 0,
                        },
                        manualCalculationScoring: {
                            quotationItem: null,
                            personCount: 3,
                            description: '',
                            standardScore: 0,
                        },
                        standardQuoteScoring: {
                            quotationItem: null,
                            quoteLowPrice: 0.00,
                            quoteLowScore: 0.00,
                            priceEqStandardScore: 100.00,
                            minPriceScore: 0.00,
                            maxPriceScore: 100.00,
                            description: '',
                            standardScore: 0,
                        }
                    }

                    if (method04 === 1) {
                        result04.deviationRateScoring = {
                            ...result04.deviationRateScoring,
                            ...rule,
                            quotationItem: quotationItem04,
                        }
                    } else if (method04 === 2) {
                        result04.manualCalculationScoring = {
                            ...result04.manualCalculationScoring,
                            ...rule,
                            quotationItem: quotationItem04,
                        }
                    } else if (method04 === 3) {
                        result04.standardQuoteScoring = {
                            ...result04.standardQuoteScoring,
                            ...rule,
                            quotationItem: quotationItem04,
                        }
                    }

                    return result04

                case '05': // 推荐候选人
                    return {
                        ...baseData,
                        method: rule.method || null,
                        recommendType: rule.method || 1,
                        personCount: rule.personCount || 3,
                        // 推荐时基于的报价项：后端可能存的是数字，这里统一转成字符串，和 ComprehensiveScoringCandidateForm/LowestPriceCandidateForm 中的 id 类型保持一致
                        quotationItem: (rule.quotationItem != null && rule.quotationItem !== undefined)
                            ? String(rule.quotationItem)
                            : ''
                    }

                case '0601': // 二次报价环节
                    return {
                        ...baseData,
                        optionalType: 1,
                        ...rule
                    }

                case '0602': // 小微企业认证环节
                    return {
                        ...baseData,
                        optionalType: 2,
                        ...rule
                    }

                default:
                    return {
                        ...baseData,
                        ...rule,
                        itemList
                    }
            }
        },

        // 根据 stepTypeCode 打开对应弹窗
        handleStepTypeClickByCode(code) {
            this.showDropdown = false
            this.showSubmenu = false

            // 从stepTypeList中获取对应的步骤类型信息
            const stepTypeInfo = this.stepTypeList.find(item => item.stepTypeCode === code)
            if (stepTypeInfo) {
                // 保存当前选中的步骤类型信息（包含id作为bindStepId和stepTypeCode）
                this.currentStepTypeInfo = {
                    stepTypeCode: stepTypeInfo.stepTypeCode,
                    bindStepId: stepTypeInfo.id,
                    stepTypeName: stepTypeInfo.stepTypeName
                }
            }

            const map = {
                '01': () => { this.showModal = true },
                '02': () => { this.showScoringModal = true },
                '03': () => { this.showBenchmarkModal = true },
                '04': () => { this.showScoringCalculationModal = true },
                '05': () => { this.showCandidateModal = true },
                '0601': () => { this.showSecondQuotationModal = true },
                '0602': () => { this.showSMEModal = true },
            }
            if (map[code]) {
                map[code]()
            } else {
                this.$message.info(`未识别的步骤类型: ${code}`)
            }
        },

        // 更新当前步骤数据（右侧表单数据变更时触发）
        updateCurrentStepData(newData) {
            if (this.currentStepData) {
                Object.assign(this.currentStepData, newData)
            }
        },

        // 更新弹窗表单数据
        updateFormData(newData) {
            Object.assign(this.formData, newData)
        },
        updateScoringFormData(newData) {
            Object.assign(this.scoringFormData, newData)
        },
        updateBenchmarkFormData(newData) {
            Object.assign(this.benchmarkFormData, newData)
        },
        updateScoringCalculationFormData(newData) {
            Object.assign(this.scoringCalculationFormData, newData)
        },
        updateCandidateFormData(newData) {
            Object.assign(this.candidateFormData, newData)
        },
        updateSecondQuotationFormData(newData) {
            Object.assign(this.secondQuotationFormData, newData)
        },
        updateSMEFormData(newData) {
            Object.assign(this.smeFormData, newData)
        },

        // 关闭弹窗方法
        closeModal() {
            this.showModal = false
            this.resetFormData()
            this.$nextTick(() => { this.clearStuckModalMask() })
        },
        closeScoringModal() {
            this.showScoringModal = false
            this.resetScoringFormData()
            this.$nextTick(() => {
                this.clearStuckModalMask()
            })
        },
        closeBenchmarkModal() {
            this.showBenchmarkModal = false
            this.resetBenchmarkFormData()
            this.$nextTick(() => { this.clearStuckModalMask() })
        },
        closeScoringCalculationModal() {
            this.showScoringCalculationModal = false
            this.resetScoringCalculationFormData()
            this.$nextTick(() => { this.clearStuckModalMask() })
        },
        closeCandidateModal() {
            this.showCandidateModal = false
            this.resetCandidateFormData()
            this.$nextTick(() => { this.clearStuckModalMask() })
        },
        closeSecondQuotationModal() {
            this.showSecondQuotationModal = false
            this.resetSecondQuotationFormData()
            this.$nextTick(() => { this.clearStuckModalMask() })
        },
        closeSMEModal() {
            this.showSMEModal = false
            this.resetSMEFormData()
            this.$nextTick(() => { this.clearStuckModalMask() })
        },
        // 重置表单数据方法
        resetFormData() {
            this.formData = { stepName: '', isBlindReview: 0, reviewItems: [{ reviewName: '', reviewStandard: '' }] }
        },
        resetScoringFormData() {
            this.scoringFormData = {
                stepName: '',
                isBlindReview: 0,
                score: 100,
                scoreType: 1,
                addUpScore: true,
                maxScoreCount: 0,
                minScoreCount: 0,
                stepMarkType: 1,
                lastScoreSetting: 1,
                followUpSetting: 1,
                followUpCount: 1,
                skipStep: false,
                bidPersonCount: 0,
                scoreReasonType: '0',
                percent: 0,
                scoreReviewList: [{ id: 1, reviewName: '', reviewStandard: '', scoreRange: '', scoreType: 1 }]
            }
        },
        resetBenchmarkFormData() {
            this.benchmarkFormData = { stepName: '', calculateType: null }
        },
        resetScoringCalculationFormData() {
            this.scoringCalculationFormData = { stepName: '', calculateType: null }
        },
        resetCandidateFormData() {
            this.candidateFormData = { stepName: '', recommendType: null, quotationItem: '', personCount: 3 }
        },
        resetSecondQuotationFormData() {
            this.secondQuotationFormData = { stepName: '' }
        },
        resetSMEFormData() {
            this.smeFormData = { stepName: '', discount: null, discountType: null, overMaxScore: false }
        },

        // ========== 保存步骤排序 ==========
        // 提交步骤排序信息到后端
        async saveStepSettings(silent = false) {
            // 构建步骤详情数组
            const stepDetail = this.leftSteps.map((item, index) => ({
                orderNum: item.orderNum || (index + 1),
                stepTypeCode: item.stepTypeCode || '',
                stepId: item.id || '',
                bindStepId: item.bindStepId || 0,
                stepName: item.stepName || '',

            }))
            let data = {
                sectionId: this.sectionId,
                stepDetail
            }

            try {
                const res = await saveStep(data)
                if (res?.code === 200) {
                    this.$message.success('保存成功')
                    this.localStepOrder = null
                    this.getSubmitStatus()
                } else {
                    this.$message.error(res?.msg || '保存失败')
                }
            } catch (e) {
                this.$message.error('保存失败')
            }
        },
    },

}
</script>

<style lang="less" scoped>
.page-top-header {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    justify-content: end;
    padding: 0 20px;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    box-sizing: border-box;
    flex-shrink: 0;
}

.main-content {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #e6e6e6;

    .content-area {
        flex: 1;
        display: flex;
        min-height: 0;
        overflow: hidden;
    }

    .left-content {
        width: 400px;
        background-color: white;
        overflow-y: auto;

        position: relative;
        margin-right: 5px;

        .left-content-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 30px;
            cursor: pointer;
            transition: all 0.3s ease;
            border-bottom: 1px solid #f0f0f0;
            font-size: 14px;

            &:hover {
                background-color: #f5f7fa;
            }

            &.active {
                background-color: #e6f7ff;
                border-left: 3px solid #409eff;
                color: #409eff;
            }

            .left-content-item-button {
                display: flex;
                align-items: center;
                gap: 12px;
                color: #409eff;
                font-size: 16px;
                font-weight: bold;
            }
        }

        .left-content-header {
            display: flex;
            align-items: flex-start;
            padding: 30px;
            gap: 12px;
            border-bottom: 1px solid #e6e6e6;

            .step-action-wrapper {
                display: flex;
                flex-direction: column;
                gap: 12px;
                width: 100%;

                .el-select {
                    width: 320px;
                }
            }

            .step-action-buttons {
                display: flex;
                align-items: center;
                gap: 5px;
            }
        }

        // 下拉菜单样式
        .dropdown-menu {
            position: absolute;
            top: 80px;
            left: 30px;
            right: 30px;
            background: white;
            border: 1px solid #e6e6e6;
            border-radius: 4px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            z-index: 1000;

            .dropdown-item {
                padding: 12px 16px;
                border-bottom: 1px solid #f0f0f0;
                transition: all 0.3s ease;
                text-align: start;
                font-size: 14px;
                color: #333;
                position: relative;
                cursor: pointer;

                &:hover {
                    background: #f5f7fa;
                    color: #409eff;
                }

                &:last-child {
                    border-bottom: none;
                }

                // 有子菜单的项
                &.has-submenu {
                    cursor: pointer;

                    &:hover {
                        background: #f5f7fa;
                        color: #409eff;
                    }
                }

                // 子菜单样式
                .submenu {
                    position: absolute;
                    left: 0;
                    top: 100%;
                    min-width: 100%;
                    background: white;
                    border: 1px solid #e6e6e6;
                    border-radius: 4px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    z-index: 1001;

                    .submenu-item {
                        padding: 12px 16px;
                        cursor: pointer;
                        border-bottom: 1px solid #f0f0f0;
                        transition: all 0.3s ease;
                        font-size: 14px;
                        color: #333;
                        white-space: nowrap;

                        &:hover {
                            background: #f5f7fa;
                            color: #409eff;
                        }

                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }
            }
        }
    }

    .right-content {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        background-color: white;

        .right-content-header {
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px;
            border-bottom: 1px solid #e6e6e6;
        }

        .right-content-body {
            padding: 30px;
            height: calc(100% - 80px);
            overflow-y: auto;
        }
    }
}

// 模版弹窗样式
.template-dialog-content {
    .template-section {
        margin-bottom: 20px;

        .template-section-title {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            margin-bottom: 16px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e6e6e6;
        }

        .template-list {
            .template-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 16px;
                border: 1px solid #e6e6e6;
                border-radius: 4px;
                margin-bottom: 12px;
                transition: all 0.3s;

                &:hover {
                    border-color: #409eff;
                    background-color: #f5f7fa;
                }

                .template-name {
                    font-size: 14px;
                    color: #333;
                }

                .el-button--text {
                    font-size: 14px;
                }
            }
        }
    }
}

// 弹窗样式
.review-form {
    .form-item {
        margin-bottom: 16px;
        text-align: start;

        &.section-item {
            .el-form-item__label {
                font-weight: 500;
                color: #333;
            }
        }
    }
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .section-title {
        font-size: 14px;
        color: #333;
        font-weight: 500;
    }

    .button-group {
        display: flex;
        gap: 8px;
    }
}

.review-table {
    .el-table {
        .el-table__header {
            th {
                background-color: #f5f7fa;
                color: #333;
                font-weight: 500;
            }
        }

        .el-table__body {
            td {
                padding: 8px;
            }
        }
    }
}

.dialog-footer {
    text-align: center;
    padding: 20px 0;
}

.empty-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #909399;

    i {
        font-size: 48px;
        margin-bottom: 16px;
        color: #c0c4cc;
    }

    p {
        font-size: 14px;
        margin: 0;
    }
}

.right-empty {
    height: 100%;
    min-height: 400px;
}

/* 复制评标办法弹窗样式 */
.copy-dialog-content {
    padding: 0 0 0 0;
}

.copy-search-bar {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-start;

    .copy-search-input {
        width: 320px;
    }
}

.copy-section-list {
    padding: 8px 16px;
    background-color: #fafbfc;
}

.copy-section-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px dashed #ebeef5;

    &:last-child {
        border-bottom: none;
    }

    .copy-section-name {
        color: #606266;
        font-size: 13px;
    }
}

.copy-pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}
</style>
